module.exports = __webpack_public_path__ + "img/5bd346299f46255714ece0f20951bd94.jpg";